/**
 * Independent time operation tool to facilitate subsequent switch to dayjs
 */
import dayjs from 'dayjs'
import { isString } from './is'

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DATE_FORMAT = 'YYYY-MM-DD'

export function formatToDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
    return dayjs(date).format(format)
}

export function formatToDate(date?: dayjs.ConfigType, format = DATE_FORMAT): string {
    return dayjs(date).format(format)
}

/**
 *  获取日期格式
 * @param type
 * @returns
 */

export function useDateFormatType(type: number): string {
    let format = ''

    switch (type) {
        case 1:
            format = 'YYYY-MM-DD HH:mm:ss'
            break
        case 2:
            format = 'YYYY-MM-DD 00:00:00'
            break
        case 3:
            format = 'YYYY-MM-DD 23:59:59'
            break
        case 4:
            format = 'YYYY-MM-DD'
            break
        case 5:
            format = 'YYYY年MM月DD日'
            break
        case 6:
            format = 'YYYY-MM-DD HH:mm'
            break
        case 7:
            format = 'MM-DD HH:mm'
            break
        case 8:
            format = 'MM月DD日 HH时mm分'
            break
        case 9:
            format = 'MM月DD日 HH时'
            break
        case 10:
            format = 'DD日HH时'
            break
        case 11:
            format = 'DD日HH时mm分'
            break
        case 12:
            format = 'YYYY-MM-DD HH:00:00'
            break
        case 13:
            format = 'MM-DD HH:mm'
            break
        case 14:
            format = 'YYYY年MM月DD日 HH时mm分ss秒'
            break
        case 15:
            format = 'YYYY-MM-DD 08:00:00'
            break
        default:
            format = 'YYYY-MM-DD HH:mm:ss'
            break
    }

    return format
}

/**
 * 构建日期
 * @param type
 * @param date
 * @returns
 */

export function buildDateParams(date: string | dayjs.Dayjs = dayjs(), type = 1) {
    const isStr = isString(type)
    return dayjs(date).format(isStr ? type : useDateFormatType(type))
}

export const dateUtil = dayjs
